import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const notify = useCallback((message, kind = "success") => {
    const id = Date.now();
    setToast({ message, kind, id });
    window.setTimeout(
      () => setToast((current) => (current?.id === id ? null : current)),
      3400,
    );
  }, []);

  const dismissToast = useCallback(() => setToast(null), []);
  const value = useMemo(
    () => ({ toast, notify, dismissToast }),
    [toast, notify, dismissToast],
  );

  return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) throw new Error("useToast must be used inside ToastProvider");
  return context;
}
